import { Navigate, Outlet, useLocation } from "react-router-dom";

// Wraps every private route. Two gates:
//   1. No token → login.
//   2. New member/HR accounts that haven't completed the first-login
//      onboarding wizard are pinned to /start until they finish it.
const AuthRoute = () => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  let owesOnboarding = false;
  try {
    const user = JSON.parse(localStorage.getItem("userdata") || "{}");
    const role = String(user.role || "").toLowerCase();
    owesOnboarding =
      user.profile_completed === 0 && (role === "member" || role === "hr");
  } catch {}

  if (owesOnboarding && location.pathname !== "/start") {
    return <Navigate to="/start" replace />;
  }

  return <Outlet />;
};

export default AuthRoute;
